// Mock data for Arnab Sarkar's Portfolio - FINAL VERSION
// All actual thumbnails, reviews, and content

export const personalInfo = {
  name: "Arnab Sarkar",
  tagline: "Thumbnail Strategist • Video Editor • Developer",
  phone: "+91 9007731807",
  email: "arnabsarkarprofessional@gmail.com",
  devPortfolio: "https://arnabsarkardev.in/",
  availability: "Available Worldwide • Remote"
};

export const thumbnailStats = {
  views: "70+ Million",
  headline: "Visual Engineering & CTR Optimization",
  keywords: [
    "Viral Strategy",
    "A/B Testing",
    "Click Psychology",
    "Pattern Interruption",
    "Thumbnail Mastery",
    "Visual Hooks"
  ]
};

// All 30 Thumbnails organized - Before/After pairs and standalone
export const thumbnails = [
  // Before/After Pairs
  {
    id: "1",
    title: "CAR REVIEW",
    category: "Reaction",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/9t119m61_CAR%20REVIEW%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/445jbww5_CAR%20REVIEW.png",
    hasBeforeAfter: true
  },
  {
    id: "2",
    title: "Finance Podcast",
    category: "Podcast",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/x2mrbzdp_Finance%20Podcast%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/psd71ie2_Finance%20Podcast.png",
    hasBeforeAfter: true
  },
  {
    id: "3",
    title: "Geo-Politics Podcast",
    category: "Podcast",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/32q31pbi_Geo-Politics%20Podcast%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/g1cayw9g_Geo-Politics%20Podcast.png",
    hasBeforeAfter: true
  },
  {
    id: "4",
    title: "GTA 6",
    category: "Gaming",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/kxaxsn6o_GTA%206%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/n5ea58yz_GTA%206.png",
    hasBeforeAfter: true
  },
  {
    id: "5",
    title: "Investment Podcast",
    category: "Podcast",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/t0wk9eok_Investment%20Podcast%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/aqw5ef27_Investment%20Podcast.png",
    hasBeforeAfter: true
  },
  {
    id: "6",
    title: "Minecraft Christmas",
    category: "Gaming",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/09yxcuon_MINECRAFT%20CHRISTMASS%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/6ix54l0e_MINECRAFT%20CHRISTMASS.png",
    hasBeforeAfter: true
  },
  {
    id: "7",
    title: "Monster Podcast",
    category: "Podcast",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/yr4f6poo_Monster%20Podcast%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/v14fzxq6_Monster%20Podcast.png",
    hasBeforeAfter: true
  },
  {
    id: "8",
    title: "Reaction Meme Review",
    category: "Reaction",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/dknux2qx_REACTION%20MEME%20REVIEW%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/82om1pqx_REACTION%20MEME%20REVIEW.png",
    hasBeforeAfter: true
  },
  {
    id: "9",
    title: "007 Memes",
    category: "Reaction",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/cqq5pqyo_REACTION%20MEME%20REVIEW%20MANIPULATION%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/nktp1mvj_REACTION%20MEME%20REVIEW%20MANIPULATION.png",
    hasBeforeAfter: true
  },
  {
    id: "10",
    title: "Great Designs Review",
    category: "Reaction",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/ov2874ho_REACTION%20REVIEW%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/9a036m9v_REACTION%20REVIEW.png",
    hasBeforeAfter: true
  },
  {
    id: "11",
    title: "Channel Deleted",
    category: "Reaction",
    beforeAfter: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/wzob4v51_REACTION%20TALKING%20HEAD%20Before%20-%20After.png",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/4hlojdzh_REACTION%20TALKING%20HEAD.png",
    hasBeforeAfter: true
  },
  // Standalone Thumbnails
  {
    id: "12",
    title: "Minecraft",
    category: "Gaming",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/xt4vg6js_MINECRAFT.png",
    hasBeforeAfter: false
  },
  {
    id: "13",
    title: "iPhone 17 Pro",
    category: "Tech",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/jcxuw64i_IPHONE%2017%20PRO.png",
    hasBeforeAfter: false
  },
  {
    id: "14",
    title: "PC Build",
    category: "Tech",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/qmi8wwnc_PC%20BUILD.png",
    hasBeforeAfter: false
  },
  {
    id: "15",
    title: "Poor vs Rich Gamer",
    category: "Gaming",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/a11qvri4_POOR%20VS%20RICH%20GAMER.png",
    hasBeforeAfter: false
  },
  {
    id: "16",
    title: "Rare Phone",
    category: "Tech",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/tywsmod1_RARE%20PHONE.png",
    hasBeforeAfter: false
  },
  {
    id: "17",
    title: "Sky Dive",
    category: "Lifestyle",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/ah8mydal_SKY%20DIVE.png",
    hasBeforeAfter: false
  },
  {
    id: "18",
    title: "Social Media Addiction",
    category: "Lifestyle",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/y0203kzr_SOCIAL%20MEDIA%20ADDICTION.png",
    hasBeforeAfter: false
  },
  {
    id: "19",
    title: "Water Slide",
    category: "Lifestyle",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/ra2pzucl_Water%20Sldie.png",
    hasBeforeAfter: false
  },
  {
    id: "20",
    title: "Indians Are Crazy",
    category: "Reaction",
    after: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/82om1pqx_REACTION%20MEME%20REVIEW.png",
    hasBeforeAfter: false
  }
];

export const videoEditingInfo = {
  headline: "Retention-Focused Video Editing",
  subheadline: "Helped 16+ TOP Content Creators and Influencers grow their brand",
  stats: {
    creators: "16+",
    satisfaction: "100%",
    turnaround: "Rapid"
  }
};

// Actual reviews from clients
export const reviews = [
  {
    id: "1",
    name: "Heli Ved",
    role: "YouTuber",
    subscribers: "570K",
    rating: 5,
    text: "Arnab is very skilled at vlog format editing. He takes the time to understand each project he works on. We are pleased to associate with him.",
    image: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/hzavi0qb_Heli%20Ved%20Review.png",
    verified: true
  },
  {
    id: "2",
    name: "Shivani Kapoor",
    role: "Fashion & Lifestyle Creator",
    subscribers: "49.6K",
    rating: 5,
    text: "He is quite hard working and put extra efforts in building creativity. His skill set has impressed me. I'm giving him an extra point for coming out of his comfort zone to create great content in the fashion and lifestyle industry.",
    image: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/6h4iez30_Shivani%20Kapoor%20Review.png",
    verified: true
  }
];

// Actual recommendation letter
export const recommendationLetter = {
  title: "Letter of Recommendation",
  from: "Heli Ved",
  position: "Digital Content Creator",
  subscribers: "570K",
  date: "September 15, 2024",
  content: `I am pleased to write this letter of recommendation for Mr. Arnab Sarkar, who has been an invaluable part of my team for the past year as a video editor. I wholeheartedly recommend him for any position that seeks a dedicated and talented professional.

During his time with us, Arnab consistently demonstrated exceptional skills in video editing, bringing creativity and technical expertise to every project. His attention to detail and ability to understand the vision behind our content set him apart as a standout editor. Arnab is adept at using various editing software and has an impressive knack for storytelling through visuals, which has significantly enhanced our projects.

Beyond his technical skills, Arnab is a hard worker who is always willing to go the extra mile. He approached each project with enthusiasm and dedication, often meeting tight deadlines while maintaining high standards of quality. His reliability and commitment to his craft have made a positive impact on our team and the overall workflow.

Arnab is also a great team player. He collaborates seamlessly with colleagues, offering constructive feedback and support. His positive attitude and willingness to share his knowledge foster a collaborative environment, making him a pleasure to work with.

In summary, I have no doubt that Arnab will be an asset to any organization he joins. His hard work, creativity, and team spirit make him a remarkable video editor and a valued team member. I highly recommend him.`,
  pdfUrl: "https://customer-assets.emergentagent.com/job_glassmorphic-folio/artifacts/e6sj77fl_Heli%20Ved%20Recommendation%20Letter%20for%20Arnab%20Sarkar.pdf",
  email: "teamhelived@gmail.com",
  website: "www.helived.co",
  phone: "+91 9653253426"
};

export const seoInfo = {
  headline: "Search Engine Dominance",
  subheadline: "Algorithm Mastery & Metadata Optimization",
  services: [
    "Keyword Research",
    "Metadata Optimization",
    "Algorithm Strategy",
    "Analytics & Insights"
  ]
};

export const developmentInfo = {
  headline: "Web & App Development",
  targetAudience: "For Businesses, Enterprises, and Influencers",
  services: [
    "Web Development",
    "App Development",
    "Custom Software",
    "UI/UX Design"
  ],
  portfolioLink: "https://arnabsarkardev.in/"
};

export const trustBannerItems = [
  "100% Client Satisfaction",
  "24/7 Client Support",
  "Rapid Turnaround",
  "Confidentiality Guaranteed",
  "Premium Quality",
  "Global Reach"
];

export const navigationItems = [
  { id: "home", label: "Home" },
  { id: "thumbnails", label: "Thumbnails" },
  { id: "editing", label: "Editing" },
  { id: "seo", label: "SEO" },
  { id: "development", label: "Development" },
  { id: "contact", label: "Contact" }
];

export const performanceMetrics = {
  views: 70,
  retention: 85,
  ctr: 12,
  subscribers: 500
};

// CTR Services
export const ctrServices = [
  {
    title: "A/B Testing",
    description: "Multiple thumbnail variations tested to find the highest performing design",
    icon: "split"
  },
  {
    title: "Click Psychology",
    description: "Leveraging human psychology principles to maximize curiosity and clicks",
    icon: "brain"
  },
  {
    title: "Pattern Interruption",
    description: "Bold designs that stand out in crowded feeds and suggested videos",
    icon: "zap"
  },
  {
    title: "Face Optimization",
    description: "Strategic use of expressive faces for 38% higher engagement",
    icon: "user"
  },
  {
    title: "Color Theory",
    description: "Contrasting color palettes that pop against YouTube's white interface",
    icon: "palette"
  },
  {
    title: "Typography Mastery",
    description: "Bold, readable text that communicates value in under 2 seconds",
    icon: "type"
  }
];

// Why Choose Me
export const whyChooseMe = [
  { stat: "70M+", label: "Views Generated" },
  { stat: "16+", label: "Top Creators" },
  { stat: "100%", label: "Client Satisfaction" },
  { stat: "24/7", label: "Support Available" }
];

// Process steps
export const processSteps = [
  { step: 1, title: "Discovery Call", description: "Understanding your brand, audience, and goals" },
  { step: 2, title: "Research & Strategy", description: "Analyzing competitors and top performers" },
  { step: 3, title: "Design & Iterate", description: "Creating concepts and refining based on feedback" },
  { step: 4, title: "Deliver & Optimize", description: "Final delivery with A/B testing recommendations" }
];

// Thumbnail categories for filtering
export const thumbnailCategories = ["All", "Reaction", "Gaming", "Podcast", "Tech", "Lifestyle"];
